var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7891 14.4606C17.7891 11.0306 20.5696 8.25 23.9996 8.25C27.4296 8.25 30.2102 11.0306 30.2102 14.4606V21.6875H17.7891V14.4606Z",
    stroke: "#4C4AEB",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0004 15.7429C24.0001 15.7524 24 15.7619 24 15.7715V41.0001H9.50008C8.91341 41.0001 8.45277 40.4974 8.50388 39.9129L10.5377 16.6558C10.5829 16.1393 11.0154 15.7429 11.5339 15.7429H24.0004Z",
    fill: "url(#paint0_linear_11184_60485)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 41.0001H38.4998C39.0864 41.0001 39.5471 40.4974 39.496 39.9129L37.4621 16.6558C37.417 16.1393 36.9844 15.7429 36.4659 15.7429H24V41.0001Z",
    fill: "url(#paint1_linear_11184_60485)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11184_60485",
    x1: 16.2502,
    y1: 15.7429,
    x2: 16.2502,
    y2: 41.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1FF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11184_60485",
    x1: 31.7499,
    y1: 15.7429,
    x2: 31.7499,
    y2: 41.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/중고장터.b85c962590884964c5b7903a7b329fb0.svg";
export { ForwardRef as ReactComponent };